import React, { Fragment } from "react";
import { Row, Col } from "react-bootstrap";
import { withHeaderMessages } from "../higherOrderComponents/WithHeaderMessages";
import "./clearpoint-reports.css";
import { Currency } from "../lib/components/Currency";
import { WithApiAccess } from "../lib/HigherOrderComponents/WithApiAccess";
import { LoadingSpinner } from "../lib/components/LoadingSpinner";
import { FormattedDate } from "../lib/components/FormattedDate";
import { Address } from "../lib/components/Address";

const ConfirmationReceiptPrintKy = (props) => {
  const { contract, downPayment, fundingOptions } = props;
  if (!contract || downPayment === null || !fundingOptions) {
    return <LoadingSpinner />;
  }

  const recipient =
    contract.recipients.length > 0
      ? contract.recipients[0]
      : {
          firstName: "",
          lastName: "",
          address: {},
        };

  return (
    <Fragment>
      <Row>
        <Col xs={12} style={{ textAlign: "center" }}>
          <img
            src="/images/confirmation_receipt.png"
            alt="Clearpoint Trust Confirmation Receipt Header Logo"
            className="confirmation-img"
          />
        </Col>
      </Row>
      <Row className="notice-row">
        <Col xs={12}>
          <h3 className="notice-header">NOTICE</h3>
          <p className="notice">
            Enclosed you will find two confirmation receipts.
          </p>
          <p className="notice">
            One is for the funeral home file and is to be submitted to
            ClearPoint at the time of death to pay the distribution.
          </p>
          <p className="notice">
            The second confirmation receipt is for the family. Because there is
            not a policy/certificate generated for a trust agreement, this
            confirmation receipt can be provided to them as proof that
            ClearPoint Trust has issued the trust.
          </p>
          <p className="notice">
            If you have any questions, please contact Customer Service at
            1-800-763-0234.
          </p>
        </Col>
      </Row>
      <Row style={{ pageBreakBefore: "always" }}>
        <Col xs={12}>
          <img
            src="/images/confirmation_receipt.png"
            alt="Clearpoint Trust Confirmation Receipt Header Logo"
            className="confirmation-img"
          />
        </Col>
      </Row>
      <Row>
        <Col xs={6}>
          <Row className="confirmation-row">
            <Col>
              <label>Funeral Provider:</label>
              <div>
                {contract.provider.name}
                <br />
                <Address address={contract.provider.address} />
              </div>
            </Col>
          </Row>
          <Row className="confirmation-row">
            <Col>
              <label>Funeral Recipient:</label>
              <div>
                {recipient.firstName} {recipient.lastName}
                <br />
                <Address address={recipient.address} />
              </div>
            </Col>
          </Row>
          <Row className="confirmation-row">
            <Col>
              <label>Funeral Purchaser:</label>
              <div>
                {contract.purchaser.firstName} {contract.purchaser.lastName}
                <br />
                <Address address={contract.purchaser.address} />
              </div>
            </Col>
          </Row>
        </Col>
        <Col xs={6}>
          <Row className="confirmation-row">
            <Col xs={12} className="col-label agreement-number">
              <label>Agreement Number:</label>&nbsp;{contract.number}
            </Col>
          </Row>
          <Row className="confirmation-row">
            <Col>
              <label>Amount Received:</label> <Currency amount={downPayment} />
            </Col>
          </Row>
          <Row className="confirmation-row">
            <Col>
              <label>Date Accepted:</label>{" "}
              <FormattedDate date={contract.accepted} format="MMMM D, YYYY" />
            </Col>
          </Row>
          <Row className="confirmation-row">
            <Col>
              <label>Payment Plan:</label>{" "}
              {(contract.numberOfPayments || 0) > 0 ? "Multipay" : "Single Pay"}
            </Col>
          </Row>
          <Row className="confirmation-row">
            <Col>
              <label>Funding Option(s):</label>
              {fundingOptions.map((f, i) => (
                <div key={i}>
                  {f}
                  <br />
                </div>
              ))}
            </Col>
          </Row>
        </Col>
      </Row>
      <Row style={{ marginBottom: ".125in", marginTop: ".375in" }}>
        <Col xs={12}>
          <img
            src="/images/ClearPoint_Confirmation_Receipt_center_2026.png"
            alt="center rule"
            className="confirmation-img"
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <Row className="confirmation-row">
            <p>
              This document is intended as a convenience to our customers and is
              not to be construed as a part of the trust contract. If this
              information differs in any way from the Funeral Planning Trust
              Agreement or Trust Funding Option Form, please call us immediately
              at 1-800-763-0234.
            </p>
            <p>
              This portion must be completed by the funeral provider at the time
              of death and sent to Customer Service via fax at 1-866-208-1236 or
              e-mail at customer.service@clearpointfederal.com.
            </p>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <Row className="confirmation-row">
            <Col className="col-label">
              <label>Agreement Number:</label>&nbsp;&nbsp;&nbsp;&nbsp;
              {contract.number}
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="confirmation-row">
        <Col xs={2} className="col-label">
          <Row>
            <label>Date of Death:</label>
          </Row>
        </Col>
        <Col xs={5}>
          <Row className="signature">&nbsp;</Row>
        </Col>
      </Row>
      <Row className="confirmation-row">
        <Col xs={12}>
          <Row>
            <p>
              The individuals signing below (Signatories") hereby certify that
              all information provided above is true to the best of their
              knowledge and that the agreed upon funeral goods and services were
              furnished. In addition, the Signatories hereby attest that the
              Funeral Recipient named above has died on the date given. The
              Signatories further understand and agree that ClearPoint Trust
              reserves the right to request more information.
            </p>
          </Row>
        </Col>
      </Row>
      <Row className="confirmation-row">
        <Col xs={4} className="col-label">
          <Row>
            <label>Signature of Authorized Funeral Firm Representative:</label>
          </Row>
        </Col>
        <Col xs={5}>
          <Row className="signature">&nbsp;</Row>
        </Col>
        <Col xs={1}>
          <Row className="date-right">
            <label>Date:</label>
          </Row>
        </Col>
        <Col xs={2}>
          <Row className="signature">&nbsp;</Row>
        </Col>
      </Row>
      <Row className="confirmation-row">
        <Col xs={4} className="col-label">
          <Row>
            <label>Print Name:</label>
          </Row>
        </Col>
        <Col xs={5}>
          <Row className="signature">&nbsp;</Row>
        </Col>
      </Row>
      <Row className="confirmation-row">
        <Col xs={4} className="col-label">
          <Row>
            <label>Signature of Legal Representative:</label>
          </Row>
        </Col>
        <Col xs={5}>
          <Row className="signature">&nbsp;</Row>
        </Col>
        <Col xs={1}>
          <Row className="date-right">
            <label>Date:</label>
          </Row>
        </Col>
        <Col xs={2}>
          <Row className="signature">&nbsp;</Row>
        </Col>
      </Row>
      <Row className="confirmation-row">
        <Col xs={4} className="col-label">
          <Row>
            <label>Relationship to Recipient:</label>
          </Row>
        </Col>
        <Col xs={5}>
          <Row className="signature">&nbsp;</Row>
        </Col>
      </Row>
      <Row style={{ marginTop: ".375in" }}>
        <Col xs={12}>
          <img
            src="/images/ClearPoint_Confirmation_Receipt_footer_2026.png"
            alt="footer"
            className="confirmation-img"
          />
        </Col>
      </Row>

      <Row style={{ pageBreakBefore: "always" }}>
        <Col xs={12}>
          <img
            src="/images/confirmation_receipt.png"
            alt="Clearpoint Trust Confirmation Receipt Header Logo"
            className="confirmation-img"
          />
        </Col>
      </Row>
      <Row>
        <Col xs={6}>
          <Row className="confirmation-row">
            <Col>
              <label>Funeral Provider:</label>
              <div>
                {contract.provider.name}
                <br />
                <Address address={contract.provider.address} />
              </div>
            </Col>
          </Row>
          <Row className="confirmation-row">
            <Col>
              <label>Funeral Recipient:</label>
              <div>
                {recipient.firstName} {recipient.lastName}
                <br />
                <Address address={recipient.address} />
              </div>
            </Col>
          </Row>
          <Row className="confirmation-row">
            <Col>
              <label>Funeral Purchaser:</label>
              <div>
                {contract.purchaser.firstName} {contract.purchaser.lastName}
                <br />
                <Address address={contract.purchaser.address} />
              </div>
            </Col>
          </Row>
        </Col>
        <Col xs={6}>
          <Row className="confirmation-row">
            <Col>
              <label>Agreement Number:</label> {contract.number}
            </Col>
          </Row>
          <Row className="confirmation-row">
            <Col>
              <label>Customer Ref Number:</label> {contract.providerNumber}
            </Col>
          </Row>
          <Row className="confirmation-row">
            <Col>
              <label>Amount Received:</label> <Currency amount={downPayment} />
            </Col>
          </Row>
          <Row className="confirmation-row">
            <Col>
              <label>Date Accepted:</label>{" "}
              <FormattedDate date={contract.accepted} format="MMMM D, YYYY" />
            </Col>
          </Row>
          <Row className="confirmation-row">
            <Col>
              <label>Funding Option(s):</label>
              {fundingOptions.map((f, i) => (
                <div key={i}>
                  {f}
                  <br />
                </div>
              ))}
            </Col>
          </Row>
        </Col>
      </Row>
      <Row style={{ marginTop: "1in" }}>
        <Col xs={12}>
          <Row className="confirmation-row">
            <p>
              This document serves as confirmation that a trust has been
              established in your name through ClearPoint Trust. This document
              is intended as a convenience to our customers and is not to be
              construed as a part of the contract.
            </p>
          </Row>
        </Col>
      </Row>
    </Fragment>
  );
};

export default withHeaderMessages(WithApiAccess(ConfirmationReceiptPrintKy));
